'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryPlaces = exports.loadPlace = exports.loadDetectedLocation = exports.QUERY_PLACES = exports.LOAD_PLACE = exports.LOAD_DETECTED_LOCATION = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getLatLonName = getLatLonName;
exports.doQueryPlaces = doQueryPlaces;
exports.doLoadPlace = doLoadPlace;
exports.doLoadDetectedLocation = doLoadDetectedLocation;
exports.watchLocationInputSagas = watchLocationInputSagas;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _deep = require('helpers/deep');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

var _LocationInput = require('./LocationInput.reducer');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getLatLonName),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doQueryPlaces),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadPlace),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadDetectedLocation),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchLocationInputSagas);

var LOAD_DETECTED_LOCATION = exports.LOAD_DETECTED_LOCATION = 'LOCATION_INPUT/LOAD_DETECTED_LOCATION';
var LOAD_PLACE = exports.LOAD_PLACE = 'LOCATION_INPUT/LOAD_PLACE';
var QUERY_PLACES = exports.QUERY_PLACES = 'LOCATION_INPUT/QUERY_PLACES';

var loadDetectedLocation = exports.loadDetectedLocation = function loadDetectedLocation() {
  return { type: LOAD_DETECTED_LOCATION };
};
var loadPlace = exports.loadPlace = function loadPlace(placeId) {
  return { type: LOAD_PLACE, placeId: placeId };
};
var queryPlaces = exports.queryPlaces = function queryPlaces(query) {
  return { type: QUERY_PLACES, query: query };
};

function getLatLonName(client, lat, lon) {
  var _ref, msa, areas;

  return _regenerator2.default.wrap(function getLatLonName$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, lat, lon]);

        case 2:
          _ref = _context.sent;
          msa = _ref.msa;
          areas = _ref.areas;
          return _context.abrupt('return', (0, _deep.deepExtract)('city', msa) || (0, _deep.deepExtract)('city', areas) || (0, _deep.deepExtract)('most_specific_area', areas));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doQueryPlaces(client, _ref2) {
  var query = _ref2.query;
  var detectedLocation;
  return _regenerator2.default.wrap(function doQueryPlaces$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;

          if (!query) {
            _context2.next = 7;
            break;
          }

          _context2.next = 4;
          return (0, _effects.select)(_locale.selectUserDetectedLocation);

        case 4:
          detectedLocation = _context2.sent;
          _context2.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.searchLocationAutocomplete, [client, {
            query: query,
            near: detectedLocation,
            type: 'cities'
          }], {
            key: 'locationInput_' + query
          });

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _LocationInput.setPlaceQuery)(query));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 15;
          return (0, _effects.call)(logger.warn, 'LocationInput: Failed while querying location', _context2.t0);

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 11]]);
}

function doLoadPlace(client, _ref3) {
  var placeId = _ref3.placeId;

  var _ref4, lat, lon, name;

  return _regenerator2.default.wrap(function doLoadPlace$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (placeId) {
            _context3.next = 2;
            break;
          }

          return _context3.abrupt('return');

        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.searchLocationDetails, [client, placeId]);

        case 5:
          _ref4 = _context3.sent;
          lat = _ref4.lat;
          lon = _ref4.lon;
          name = _ref4.name;
          _context3.next = 11;
          return (0, _effects.put)((0, _LocationInput.setInputLocation)({ lat: lat, lon: lon, name: name }));

        case 11:
          _context3.next = 17;
          break;

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 17;
          return (0, _effects.call)(logger.warn, 'LocationInput: Failed while retrieving place data', _context3.t0);

        case 17:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[2, 13]]);
}

function doLoadDetectedLocation(client) {
  var detectedLocation, lat, lon, name;
  return _regenerator2.default.wrap(function doLoadDetectedLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_locale.selectUserDetectedLocation);

        case 2:
          detectedLocation = _context4.sent;

          if (!(!detectedLocation || detectedLocation.lat === 0 && detectedLocation.lon === 0)) {
            _context4.next = 7;
            break;
          }

          _context4.next = 6;
          return (0, _effects.call)(logger.warn, 'LocationInput: Failed while retrieving current location data, no location', detectedLocation);

        case 6:
          return _context4.abrupt('return');

        case 7:
          _context4.prev = 7;
          lat = detectedLocation.lat, lon = detectedLocation.lon;
          _context4.next = 11;
          return (0, _effects.call)(getLatLonName, client, lat, lon);

        case 11:
          name = _context4.sent;
          _context4.next = 14;
          return (0, _effects.put)((0, _LocationInput.setInputLocation)({ lat: lat, lon: lon, name: name }));

        case 14:
          _context4.next = 20;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4['catch'](7);
          _context4.next = 20;
          return (0, _effects.call)(logger.warn, 'LocationInput: Failed while retrieving current location data', _context4.t0);

        case 20:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[7, 16]]);
}

function watchLocationInputSagas(client) {
  return _regenerator2.default.wrap(function watchLocationInputSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, QUERY_PLACES, doQueryPlaces, client);

        case 2:
          _context5.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_PLACE, doLoadPlace, client);

        case 4:
          _context5.next = 6;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_DETECTED_LOCATION, doLoadDetectedLocation, client);

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}